import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Loader } from '@entur/loader'
import { BannerAlertBox } from '@entur/alert'

const Login: React.FC<{ children: React.ReactNode }> = (props) => {
  const { isAuthenticated, error, isLoading, loginWithRedirect } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated && !isLoading && !error) {
      loginWithRedirect()
    }
  }, [isAuthenticated, isLoading, error, loginWithRedirect])

  return (
    <>
      {isLoading && <Loader>Logger inn</Loader>}
      {!isLoading && isAuthenticated && <>{props.children}</>}
      {error?.message && (
        <BannerAlertBox variant="error" title="Innlogging feilet">
          {error?.message}
        </BannerAlertBox>
      )}
    </>
  )
}

export default Login
